import React, { FunctionComponent } from 'react';
import { Settings, ProductItem, Platform, DeviceType, Orientation } from 'sofa-reborn-react';
import { KompisProductCard } from '@inter-ikea-kompis/react-components';
import ProductCardModalEnum from '@inter-ikea-kompis/component-product-card/lib/enums/ProductCardModalEnum';
import ProductCardLayoutEnum from '@inter-ikea-kompis/component-product-card/lib/enums/ProductCardLayoutEnum';
import ProductCardMediaEnum from '@inter-ikea-kompis/component-product-card/lib/enums/ProductCardMediaEnum';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import {
	IShoppingProduct,
	IStoreAvailability,
	IStore,
	IDexfSettings,
	ITranslations,
} from '@inter-ikea-kompis/types';
import { ProductDescriptionProductMeasureEnum, StringUtility } from '@inter-ikea-kompis/utilities';
import SkapaModal, {
	Sheets as SkapaSheets,
	ModalHeader as SkapaModalHeader,
	ModalBody as SkapaModalBody,
} from '@ingka/modal';

type Props = {
	settings: Settings;
	productItem: ProductItem;
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	carouselSelectedIndex: number;
	showSheet: boolean;
	visibleModal: ProductCardModalEnum | null | undefined;
	stores?: IStore[];
	storeId: string;
	storeAvailability: IStoreAvailability | null;
	isProduction: boolean;
	kompisSettings?: IDexfSettings | null;
	kompisTranslations?: ITranslations | null;
	shoppingProducts?: IShoppingProduct[];
	isSkapaFocusLockDisabled: boolean;
	onClose?: () => void;
	onModalOpen?: (e: CustomEvent) => void;
	onModalClose?: () => void;
	onCarouselChange?: (carouselSelectedIndex: number) => void;
	onStoreSelectorChange?: (e: CustomEvent) => void;
};

const AdditionalInformation: FunctionComponent<Props> = (props) => {
	const { onClose, onModalOpen, onModalClose, onCarouselChange } = props;

	if (
		props.kompisSettings &&
		props.kompisTranslations &&
		props.shoppingProducts &&
		props.shoppingProducts.length > 0
	) {
		const product = (props.shoppingProducts as IShoppingProduct[])[0].product;
		const showStoreSelector =
			props.kompisSettings.kompis.serviceSettings.storeAvailabilityDataSource !== 'disabled';

		if (product && product.content) {
			const header = product.content.typeName || null;
			return (
				<SkapaModal
					visible={props.showSheet}
					handleCloseBtn={(): void => onClose && onClose()}
					focusLockProps={{ disabled: props.isSkapaFocusLockDisabled }}
				>
					<SkapaSheets
						size={'small'}
						alignment={'right'}
						header={
							<SkapaModalHeader title={header ? StringUtility.capitalizeFirstLetter(header) : ''} />
						}
						footer={null}
						style={{
							zIndex: 10,
							borderTop:
								SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
							borderBottom:
								SkapaTheme.border.thickness.thin + 'px solid' + SkapaTheme.color.border.default,
						}}
					>
						<SkapaModalBody>
							<KompisProductCard
								theme={SkapaTheme}
								settings={props.kompisSettings}
								translations={props.kompisTranslations.kompis}
								product={product}
								layout={ProductCardLayoutEnum.information}
								media={ProductCardMediaEnum.carousel}
								productMeasures={ProductDescriptionProductMeasureEnum.long}
								carouselSelectedIndex={props.carouselSelectedIndex}
								carouselShowScrollbar={
									product.content.image ? product.content.image?.length > 1 : false
								}
								showDesignText={true}
								showProductIdentifier={true}
								stores={showStoreSelector ? (props.stores as IStore[]) : []}
								storeId={props.storeId}
								storeAvailability={props.storeAvailability || null}
								visibleModal={props.visibleModal}
								disableLinks={true}
								onModalOpen={(e: CustomEvent): void => onModalOpen && onModalOpen(e)}
								onModalClose={(): void => onModalClose && onModalClose()}
								onCarouselChange={(e: CustomEvent): void =>
									onCarouselChange && onCarouselChange(e.detail.carouselSelectedIndex)
								}
								onStoreSelectorChange={props.onStoreSelectorChange}
							></KompisProductCard>
						</SkapaModalBody>
					</SkapaSheets>
				</SkapaModal>
			);
		}
	}
	return null;
};

export default AdditionalInformation;
